export var configData ={
    apiURL : "https://gccvmapi.accenture.com/api"
    //  apiURL : "https://gccvmapippd.accenture.com/api"
    //  apiURL : "http://localhost:27819/api"
}